
import Leyora121 from './Leyora 12 (1).webp'
import Leyora122 from './Leyora 12 (2).webp'
import Leyora123 from './Leyora 12 (3).webp'
import Leyora124 from './Leyora 12 (4).webp'
import Leyora125 from './Leyora 12 (5).webp'
import Leyora126 from './Leyora 12 (6).webp'
import Leyora127 from './Leyora 12 (7).webp'
import Leyora128 from './Leyora 12 (8).webp'


const Leyora12images =[
Leyora121,Leyora122,Leyora123,Leyora124,Leyora125,Leyora126,Leyora127,Leyora128
]

export default Leyora12images;